import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=7074f9fb&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "./Help.vue?vue&type=style&index=0&id=7074f9fb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074f9fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7074f9fb')) {
      api.createRecord('7074f9fb', component.options)
    } else {
      api.reload('7074f9fb', component.options)
    }
    module.hot.accept("./Help.vue?vue&type=template&id=7074f9fb&scoped=true", function () {
      api.rerender('7074f9fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Help.vue"
export default component.exports